import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AlertService } from 'src/app/services/base/alert.service';

@Component({
  selector: 'app-karma-unavailable-badge',
  templateUrl: './karma-unavailable-badge.component.html',
  styleUrls: ['./karma-unavailable-badge.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KarmaUnavailableBadgeComponent {
  @Input() unavailable = false;
  @Input() since: string | null = null;
  @Input() model = '';
  @Input() colorname = '';
  /** Bestehender Info-Text des Artikels — der Hinweis wird daran angehängt statt ihn zu überschreiben. */
  @Input() currentInfo: string | null = null;
  /** Wenn gesetzt, wird nach der Erklärung automatisch ein Hinweis an das Artikel-Info-Feld angehängt. */
  @Input() orderId: string | null = null;
  /** Meldet den neuen Info-Text an die Elternkomponente, die ihn im Produkt des Auftrags speichert. */
  @Output() infoUpdated = new EventEmitter<string>();

  constructor(
    private alertService: AlertService,
  ) {}

  get tooltip(): string {
    if (!this.since) {
      return 'Diese Farbe wurde beim letzten Karma-Import nicht mehr gefunden — weiterhin bestellbar, aber möglicherweise nicht mehr lieferbar.';
    }
    const d = new Date(this.since).toLocaleString('de-DE', {
      day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit',
    });
    return `Nicht mehr im Karma-Katalog seit ${d} — weiterhin bestellbar, aber möglicherweise nicht mehr lieferbar.`;
  }

  async onClick(event: Event): Promise<void> {
    event.stopPropagation();

    const label = [this.model, this.colorname].filter(Boolean).join(' — ') || 'Dieses Produkt';
    const explanation = `${label} ist aktuell nicht bei Karma im Angebot. Möglich ist eine Umstellung der Farbnennung oder ein fehlender Eintrag.`;

    if (!this.orderId) {
      // Ohne Order im Kontext kann kein Info-Feld aktualisiert werden — presentInfoAlert reicht hier aus.
      await this.alertService.presentInfoAlert('Produkt nicht bei Karma im Angebot', explanation);
      return;
    }

    // presentConfirmationAlert löst erst auf, wenn der Nutzer den Dialog schließt
    // (presentInfoAlert löst schon beim Rendern auf) — sonst würde der direkt
    // folgende presentTextInputAlert wegen AlertService.isAlertActive stumm no-open.
    await this.alertService.presentConfirmationAlert(
      'Produkt nicht bei Karma im Angebot',
      explanation,
      'Weiter',
      'Schließen',
    );

    const alternative = await this.alertService.presentTextInputAlert(
      'Alternative notieren',
      `Alternative für ${label} (z. B. Ersatzfarbe/-modell), falls die Farbe nicht wieder verfügbar wird:`,
      '',
      'Speichern',
      'Überspringen',
    );

    if (alternative && alternative.trim()) {
      const newInfo = this.currentInfo?.trim() ? `${this.currentInfo.trim()} · ${alternative.trim()}` : alternative.trim();
      this.infoUpdated.emit(newInfo);
      await this.alertService.presentToast('Alternative zur Artikel-Info hinzugefügt', 2000, 'dark');
    }
  }
}
